import './assets/scss/styles.scss';
import domrfbankUi from '@ahml/domrfbank-ui';
import detectBrowser from "./assets/js/scripts/detectBrowser";
// import initLazyLoading from "./assets/js/scripts/initLazyLoading";
import initAnchors from "./assets/js/scripts/initAnchors";
import initBreadcrumbs from "./assets/js/scripts/initBreadcrumbs";
import initAnkers from "./assets/js/scripts/initAnkers";
import initBtnBack from "./assets/js/scripts/initBtnBack";
import initAnnualReport from "./assets/js/scripts/initAnnualReport";
import initArticle from "./assets/js/scripts/initArticle";
import initTopic from "./assets/js/scripts/initTopic";
import initFlipCards from "./assets/js/scripts/initFlipCards";
import initMobileFootDropdowns from "./assets/js/scripts/initMobileFootDropdowns";
import animatePromoBlock from './assets/js/scripts/animatePromoBlock';
import animateBlocks from './assets/js/scripts/animateBlocks';
import animateProductCards from "./assets/js/scripts/animateProductCards";
import animatePremiumQr from "./assets/js/scripts/animatePremiumQr";
import initSme from './assets/js/scripts/initSme';
import initYearsTabs from "./assets/js/scripts/initYearsTabs";
import animateSwitcherPlugin from "./assets/js/vue/plugins/animateSwitcherPlugin";
import initInputsFocus from "./assets/js/scripts/initInputsFocus";
import initMobileFixedTabs from "./assets/js/scripts/initMobileFixedTabs";
import initFixedHeader from "./assets/js/scripts/initFixedHeader";
import initActionsTabs from './assets/js/scripts/initActionsTabs';
import initScrollCards from './assets/js/scripts/initScrollCards';
import initFormUpload from "./assets/js/scripts/initFormUpload";
import initInsiderTabs from './assets/js/scripts/initInsiderTabs';
import initGrayTabsSwitcher from "./assets/js/scripts/initGrayTabsSwitcher";
import initStandaloneAccordeons from './assets/js/scripts/initStandaloneAccordeons';
import promoAccordeons from './assets/js/scripts/promoAccordeons';
import initCardsBenefitsSlider from './assets/js/scripts/initCardsBenefitsSlider';
import initMobileDivLink from './assets/js/scripts/initMobileDivLink';
// import initBeesender from './assets/js/scripts/initBeesender';
// import '/libs/beesender-chat';
import toggleAnswer from "./assets/js/scripts/toggleAnswer";
import yaShare from "./assets/js/scripts/yaShare";
import initSpanAnchors from "./assets/js/scripts/initSpanAnchors";

import { createApp, configureCompat, defineAsyncComponent } from 'vue';
import { registerVueDirectives } from "./assets/js/vue/directives";
import VModal from './assets/js/vue/plugins/modal.js';
import VMask from 'vue-the-mask'
import cardsMixin from './assets/js/vue/mixins/cardsMixin';
import forDevelopersMixin from './assets/js/vue/mixins/forDevelopersMixin';
import contactsMixin from './assets/js/vue/mixins/contactsMixin'
import docsMixin from './assets/js/vue/mixins/docsMixin';
import minRatesMixin from './assets/js/vue/mixins/minRatesMixin';
import mortgageProgramsMixin from './assets/js/vue/mixins/mortgageProgramsMixin';
import charterMixin from './assets/js/vue/mixins/charterMixin';
import initSmeTabs from './assets/js/scripts/initSmeTabs';
import partnersNavFilter from './assets/js/scripts/partnersNavFilter';
import aboutPageMixin from './assets/js/vue/mixins/aboutPageMixin';
import partnersFormsMixin from './assets/js/vue/mixins/partnersFormsMixin';
import shareholdersMixin from './assets/js/vue/mixins/shareholdersMixin'
import requisitesMixin from './assets/js/vue/mixins/requisitesMixin';
import stockMixin from './assets/js/vue/mixins/stockMixin';
import partnersMixin from './assets/js/vue/mixins/partnersMixin';
import premiumMixin from './assets/js/vue/mixins/premiumMixin';
import privateMixin from './assets/js/vue/mixins/privateMixin';
import seoMixin from './assets/js/vue/mixins/seoMixin';
import procurementMixin from "./assets/js/vue/mixins/procurementMixin";
import qaMixin from './assets/js/vue/mixins/qaMixin';
import loansMixin from './assets/js/vue/mixins/loansMixin';
import stockMarketMixin from './assets/js/vue/mixins/stockMarketMixin';
import escrowMixin from "./assets/js/vue/mixins/escrowMixin";
import initShareholderLp from "./assets/js/scripts/initShareholderLp";
import mobileBankMixin from "./assets/js/vue/mixins/mobileBankMixin";
import commonMixin from './assets/js/vue/mixins/commonMixin';
import bankTypeSwitcherMixin from './assets/js/vue/mixins/bankTypeSwitcherMixin';
import bankingSupportMixin from "./assets/js/vue/mixins/bankingSupportMixin";
import projectFinanceMixin from "./assets/js/vue/mixins/projectFinanceMixin";
import depositsMixin from "./assets/js/vue/mixins/depositsMixin";
import chatBotMixin from './assets/js/vue/mixins/chatBotMixin';
import tutorialMixin from './assets/js/vue/mixins/tutorialMixin';
import jsAnchor from './assets/js/vue/plugins/js-anchor';
import Sticky from '/local/templates/redesign/src/assets/js/vue/plugins/sticky.js';
import Predlogi from './assets/js/vue/plugins/predlogi/predlogi.js';
import App from './assets/js/vue/plugins/App';
import CustomRouter from './assets/js/vue/plugins/router';
import { routes } from './assets/js/vue/routes';
import store from './store';
import './components-global-lazy';
import VModalComponent from './components/vModal.vue';
import GetPhoneCodeModal from './components-manual/widgets/GetPhoneCodeModal.vue';
import ConfirmModal from './components-manual/widgets/ConfirmModal/ConfirmModal.vue';

configureCompat({
    MODE: 2,
    COMPONENT_V_MODEL: false,
    COMPILER_V_BIND_SYNC: false,
    FILTERS: false,
    COMPILER_FILTERS: false,
    COMPONENT_ASYNC: false,
    // WATCH_ARRAY: false,
});

window.RGBToHex = function (r, g, b) {
	var bin = r << 16 | g << 8 | b;
	return (function (h) {
		return new Array(7 - h.length).join("0") + h
	})(bin.toString(16).toUpperCase())
};

const customRouter = new CustomRouter({routes});
Promise.all([
    customRouter.init(),
    new Promise((res) => {
        window.addEventListener('pageshow', res);
    }),
]).then(([routerMixin]) => {
    const app = createApp({
        mixins: [
            commonMixin,
            cardsMixin,
            forDevelopersMixin,
            mortgageProgramsMixin,
            charterMixin,
            shareholdersMixin,
            aboutPageMixin,
            partnersFormsMixin,
            requisitesMixin,
            stockMixin,
            partnersMixin,
            premiumMixin,
            privateMixin,
            seoMixin,
            qaMixin,
            contactsMixin,
            docsMixin,
            minRatesMixin,
            procurementMixin,
            loansMixin,
            stockMarketMixin,
            escrowMixin,
            bankTypeSwitcherMixin,
            bankingSupportMixin,
            projectFinanceMixin,
            depositsMixin,
            chatBotMixin,
            mobileBankMixin,
            tutorialMixin,
            routerMixin,
        ],
        mounted() {
            detectBrowser();
            // initLazyLoading();
            initAnnualReport();
            initArticle();
            initTopic();
            initFlipCards();
            initMobileFootDropdowns();
            animatePromoBlock();
            animateProductCards();
            animatePremiumQr();
            initSme();
            initInputsFocus();
            initMobileFixedTabs();
            initFixedHeader();
            initBreadcrumbs();
            initAnkers();
            initBtnBack();
            initActionsTabs();
            initYearsTabs();
            initScrollCards();
            initFormUpload();
            initSmeTabs();
            initGrayTabsSwitcher();
            initInsiderTabs();
            initStandaloneAccordeons();
            promoAccordeons();
            initShareholderLp();
            initCardsBenefitsSlider();
            initMobileDivLink();
            toggleAnswer();
            partnersNavFilter();
            yaShare();
            initSpanAnchors();
        },
    });

    registerVueDirectives(app);

    app.use(VModal);
    app.use(VMask);
    app.use(jsAnchor);
    app.use(Sticky);
    app.use(Predlogi);
    app.use(App);
    app.use(animateBlocks);
    app.use(initAnchors);
    app.use(animateSwitcherPlugin);
    app.use(domrfbankUi, { rootSelector: '#app', zIndexScreen: 6 });
    app.use(store);

    app.config.compilerOptions.isCustomElement = (tag) => ['yass-i', 'yass-span', 'yass-div', 'yass-li', 'yass-ol', 'yass-h3'].includes(tag);
    app.config.compilerOptions.whitespace = 'condense';

    /**
     * Sync components registration (котсыль для модалки)
     */
    const syncComponentNames = ['d-modal', 'v-modal'];
    app.component('d-modal', VModalComponent);
    app.component('v-modal', VModalComponent);
    app.component('get-phone-codel-modal', GetPhoneCodeModal);
    app.component('confirm-modal', ConfirmModal);

    /**
     * Async components registration
     */
    const files = require.context(
        './components', // папка с компонентами
        true,           // вложенные папки
        /\.vue$/i,      // фильтр, регулярка
        'lazy'          // отложенный импорт
    );
    files.keys().forEach((key) => {
        const name = key.split('/').pop().split('.')[0];
        if (!syncComponentNames.includes(name))
            app.component(name, defineAsyncComponent(() => files(key))); // регистрация ком-та
    });

	app.mount('#app');
});

window.onpageshow = (e) => {
	const ua = window.navigator.userAgent;
	if ( (e.persisted || window.performance.navigation.type == 2) && (ua.match(/iPad/i) || ua.match(/iPhone/i)) ) {
		window.location.reload()
	}
};
